<ng-container
  *ngIf="profile && profile.role !== UserRole.PILOT && hasActivityContent"
>
  <div>
    <div class="activity-wrapper">
      <ng-container *ngIf="canShowDiagrams">
        <mat-tab-group
          *ngIf="supportsMultipleConfigurations; else singleDiagram"
          class="custom-tab"
          [selectedIndex]="0"
          (selectedIndexChange)="onDiagramTabChanged($event)"
        >
          <mat-tab [label]="'Drone_details.uav.all' | translate">
            <ng-template matTabContent>
              <app-drone-model-all [device]="device"> </app-drone-model-all>
            </ng-template>
          </mat-tab>
          <mat-tab label="Vector">
            <ng-template matTabContent>
              <app-drone-model-vector
                [device]="device"
                (configurationTypeChanged)="
                  onVectorConfigurationTypeChanged($event)
                "
              >
              </app-drone-model-vector>
            </ng-template>
          </mat-tab>
          <mat-tab label="Multicopter">
            <ng-template matTabContent>
              <app-drone-model-scorpion
                [device]="device"
                (configurationTypeChanged)="
                  onScorpionConfigurationTypeChanged($event)
                "
              >
              </app-drone-model-scorpion>
            </ng-template>
          </mat-tab>
        </mat-tab-group>

        <ng-template #singleDiagram>
          <div class="single-diagram">
            <app-drone-model-vector
              *ngIf="supportsVector"
              [device]="device"
              (configurationTypeChanged)="
                onVectorConfigurationTypeChanged($event)
              "
            >
            </app-drone-model-vector>
            <app-drone-model-scorpion
              *ngIf="supportsScorpion"
              [device]="device"
              (configurationTypeChanged)="
                onScorpionConfigurationTypeChanged($event)
              "
            >
            </app-drone-model-scorpion>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="hasMultipleTableSections; else singleTableSection">
        <div class="activity-table-tabs">
          <mat-tab-group #tableTab [selectedIndex]="0">
            <mat-tab>
              <!-- Material renders a tab header from this template, so the test id lands inside
                   the tab button. Specs then pick the tab without matching translated labels. -->
              <ng-template mat-tab-label>
                <span data-testid="activity-tab-flights-history">
                  {{ 'Drone_details.flights_history' | translate }}
                </span>
              </ng-template>
              <app-drone-flights-history
                [device]="device"
                [profile]="profile"
                [configurationType]="configurationType"
              ></app-drone-flights-history>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span data-testid="activity-tab-maintenance-logbook">
                  {{ 'Drone_details.maintenance_logbook' | translate }}
                </span>
              </ng-template>
              <app-drone-maintenance-logbook
                [device]="device"
                [configurationType]="configurationType"
              ></app-drone-maintenance-logbook>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ng-container>

      <ng-template #singleTableSection>
        <section *ngIf="hasSessions" class="activity-table-section">
          <div class="table-header activity-table-header">
            <h1>{{ 'Drone_details.flights_history' | translate }}</h1>
            <div class="line-part"></div>
          </div>
          <app-drone-flights-history
            [device]="device"
            [profile]="profile"
            [configurationType]="configurationType"
          ></app-drone-flights-history>
        </section>

        <section *ngIf="canShowMaintenance" class="activity-table-section">
          <div class="table-header activity-table-header">
            <h1>{{ 'Drone_details.maintenance_logbook' | translate }}</h1>
            <div class="line-part"></div>
          </div>
          <app-drone-maintenance-logbook
            [device]="device"
            [configurationType]="configurationType"
          ></app-drone-maintenance-logbook>
        </section>
      </ng-template>
    </div>
  </div>
</ng-container>
